import { SelectOption, withForm } from '@stern-ui/ui';

import { useFetchAllListsFilterQuery } from '../../../api';
import { generatePatientListOptions } from '../../../utils';

import { patientListFiltersFormOptions } from './patientListFiltersFormOptions';
import { PatientListFiltersFormSection } from './PatientListFiltersFormSection';

export const PatientListFiltersLists = withForm({
	...patientListFiltersFormOptions,
	render: function Render({ form }) {
		// get data to populate select options
		const { data, isSuccess } = useFetchAllListsFilterQuery({});
		const patientListOptions =
			isSuccess && data?.results
				? generatePatientListOptions(data.results)
				: ([] as SelectOption[]);

		return (
			<PatientListFiltersFormSection title='Patient list' dataTestId='filters-list-section'>
				<>
					<div className='grid grid-cols md:grid-cols-3 gap-4 md:gap-8 mt-4 pb-8'>
						<form.AppField name='person_lists_include'>
							{(field) => (
								<field.SelectField
									label='Include patients in list(s)'
									options={patientListOptions}
									isMulti={true}
								/>
							)}
						</form.AppField>
						<form.AppField name='person_lists_exclude'>
							{(field) => (
								<field.SelectField
									label='Exclude patients in list(s)'
									options={patientListOptions}
									isMulti={true}
								/>
							)}
						</form.AppField>
					</div>
				</>
			</PatientListFiltersFormSection>
		);
	},
});
